import { useMemo } from "react";

import { CloudflowEngine, type NodeConfigSystemEventTriggerParameters } from "@doitintl/cmp-models";
import { getCollection } from "@doitintl/models-any";
import { useDocumentData } from "@doitintl/models-hooks";

import { useCustomerId } from "../../../../../../Components/hooks/useCustomerId";
import { getCachingKeys } from "../../../../../../utils/cachingKeys";

export const useSystemEventModel = (eventPointer: NodeConfigSystemEventTriggerParameters) => {
  const customerId = useCustomerId();

  const eventDoc = useMemo(() => {
    if (!eventPointer.event) return undefined;

    return getCollection(CloudflowEngine)
      .doc("triggers")
      .collection("sources")
      .doc(eventPointer.source)
      .collection("models")
      .doc(eventPointer.event)
      .collection("versions")
      .doc(eventPointer.version);
  }, [eventPointer.event, eventPointer.source, eventPointer.version]);

  return useDocumentData(eventDoc, {
    caching: true,
    cachingKeys: [...getCachingKeys(customerId), "eventModel"],
  });
};
